//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Illustration, Paper, Typography } from '@backmarket/design-system'

import translations from './PickleBanner.translations'

export default {
  components: {
    Illustration,
    Paper,
    Typography,
  },
  computed: {
    translations: () => translations,
  },
}
